import React, { useEffect, useState, useRef } from 'react'
import {
  Card,
  Row,
  Col,
  FormLabel,
  FormControl,
  Tabs,
  Tab,
  Form,
} from 'react-bootstrap'
import Select from '../../../../components/Select'
import NumericInput from 'react-numeric-input'

import MaterialTable from '../../../../components/Table/DataTable'
import StockApiStore from '../StockApiStore'
import moment from 'moment'
import dot from 'dot-object'
import Swal from 'sweetalert2'
import SingleButton from 'components/Button/SingleClickButton'

export default function ReconcileInventory({ match }) {
  const { inventoryLotId } = match.params
  const tableRef = useRef(null)

  const [inventoryDetail, setInventoryDetail] = useState({})

  const handleChange = (field, value) => {
    let objValue = { ...inventoryDetail }
    dot.set(field, value, objValue)

    if (objValue.packagingLevel?.packagingLevel === 2) {
      objValue.adjustUnitQty =
        Number(objValue.adjustQty) * objValue.unitPerPackQty
    } else {
      objValue.adjustUnitQty = Number(objValue.adjustQty)
    }
    objValue.afterUnitQty = objValue.remainUnitQty + objValue.adjustUnitQty
    objValue.afterPackQty = (
      objValue.afterUnitQty / objValue.unitPerPackQty
    ).toFixed(1)

    setInventoryDetail(objValue)
  }

  const getInventoryById = (productId, warehouseId) => {
    StockApiStore.getInventoryById(productId, warehouseId, ({ data }) => {
      if (data?.data) {
        const packagingLevel = data?.data?.product?.packagingLevels?.[0] ?? null

        setInventoryDetail({
          ...inventoryDetail,
          ...data.data,
          packagingLevel: packagingLevel,
          adjustQty: '',
          adjustUnitQty: '',
          note: '',
        })
      }
    })
  }

  useEffect(() => {
    if (inventoryLotId) {
      getInventoryById(inventoryLotId)
    }
  }, [inventoryLotId])

  const saveAdjust = () => {
    if (!`${inventoryDetail.note || ''}`.trim()) {
      Swal.fire(
        'กรุณาระบุหมายเหตุ',
        'โปรดระบุเหตุผลในการปรับยอดคงคลังก่อนบันทึก',
        'warning',
      )
      return
    }

    let body = {
      adjustUnitQty: inventoryDetail.adjustUnitQty,
      note: inventoryDetail.note,
    }

    return StockApiStore.addInventoryLotAdjust(
      body,
      inventoryDetail.inventoryLotId,
      ({ status }) => {
        if (status === 200) {
          Swal.fire('สร้างรายการปรับยอด', 'สำเร็จ!', 'success')
          getInventoryById(inventoryLotId)
          tableRef.current && tableRef.current.onQueryChange()
        } else {
          Swal.fire('สร้างรายการปรับยอด', 'ไม่สำเร็จ!', 'error')
        }
      },
    )
  }

  const column = [
    {
      title: 'วันที่',
      field: 'createdAt',
      render: (rowData) =>
        rowData.createdAt &&
        moment(rowData.createdAt).add(543, 'year').format('DD/MM/YYYY'),
    },
    {
      title: 'จำนวนก่อนปรับ(unit)',
      field: 'beforeUnitQty',
    },
    {
      title: 'จำนวนปรับ (unit)',
      field: 'adjustUnitQty',
    },
    {
      title: 'คงเหลือ (unit)',
      field: 'remainUnitQty',
    },
    {
      title: 'ปรับโดย',
      field: 'createdBy.fullName',
      render: (rowData) =>
        rowData.createdBy?.fullName ||
        [rowData.createdBy?.firstName, rowData.createdBy?.lastName]
          .filter(Boolean)
          .join(' ') ||
        '-',
    },
    {
      title: 'หมายเหตุ',
      field: 'note',
    },
  ]

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title as="h5">ปรับยอดคงคลัง</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col className="my-3">
              <p>
                <span className="font-weight-bold">รหัสสินค้า:</span>
                <span className="mx-3">
                  {inventoryDetail.product?.productCode}
                </span>
                <span className="font-weight-bold">ชื่อ:</span>
                <span className="mx-3">
                  {inventoryDetail.product?.productFullName}
                </span>
                <span className="font-weight-bold">ขนาดบรรจุ:</span>
                <span className="mx-3">
                  {inventoryDetail.inventoryProductFullPackageName}
                </span>
                <span className="font-weight-bold">Item Code :</span>
                <span className="mx-3">
                  {inventoryDetail.product?.itemCode}
                </span>
              </p>
              <p>
                <span className="font-weight-bold mr-2">รายการปรับยอดคง</span>
                <span className="font-weight-bold">คลัง:</span>
                <span className="mx-3">{inventoryDetail.warehouse?.name}</span>
                <span className="font-weight-bold">เลขที่ผลิต:</span>
                <span className="mx-3">{inventoryDetail.lotNumber}</span>
                <span className="font-weight-bold">location:</span>
                <span className="mx-3">
                  {inventoryDetail.inventoryLocation?.name}
                </span>
              </p>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Card.Header>
                  <Card.Title as="h5">ปรับยอด</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col sm={6} md={5} xl={2} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col
                          xs={4}
                          sm={5}
                          xl={5}
                          className="px-2 text-sm-right"
                        >
                          <FormLabel className="m-0">จำนวนปรับ</FormLabel>
                        </Col>
                        <Col className="px-2">
                          <FormControl
                            value={inventoryDetail.adjustQty}
                            onChange={(e) =>
                              handleChange('adjustQty', e.target.value)
                            }
                            type="number"
                            placeholder="+ หรือ -"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col sm={6} md={5} xl={2} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col
                          xs={4}
                          sm={5}
                          xl={5}
                          className="px-2 text-sm-right"
                        >
                          <FormLabel className="m-0">หน่วยนับ</FormLabel>
                        </Col>
                        <Col className="px-2">
                          <Select
                            options={inventoryDetail.product?.packagingLevels}
                            getOptionLabel={(e) => e.name}
                            getOptionValue={(e) => e.packagingLevel}
                            value={inventoryDetail.packagingLevel}
                            onChange={(e) => handleChange('packagingLevel', e)}
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col sm={6} md={5} xl={2} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col
                          xs={4}
                          sm={5}
                          xl={5}
                          className="px-2 text-sm-right"
                        >
                          <FormLabel className="m-0">ราคาทุนต่อหน่วย</FormLabel>
                        </Col>
                        <Col className="px-2">
                          <NumericInput
                            style={false}
                            className={`form-control text-right`}
                            value={inventoryDetail.unitPrice}
                            step={0.5}
                            onChange={(value) =>
                              handleChange('unitPrice', value)
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={6} md={5} xl={3} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col
                          xs={4}
                          sm={5}
                          xl={5}
                          className="px-2 text-sm-right"
                        >
                          <FormLabel className="m-0">จำนวนก่อนปรับ</FormLabel>
                        </Col>
                        <Col className="px-2">
                          <FormControl
                            className="text-right"
                            value={inventoryDetail.remainUnitQty}
                            readOnly
                          />
                        </Col>
                        <span>unit / </span>
                      </Row>
                    </Col>
                    <Col sm={6} md={5} xl={2} className="px-2 ">
                      <Row className="align-items-center px-1 py-2">
                        <Col className="px-2">
                          <FormControl
                            className="text-right"
                            value={inventoryDetail.remainPackQty}
                            readOnly
                          />
                        </Col>
                        <span>pack</span>
                      </Row>
                    </Col>

                    <Col sm={6} md={5} xl={6} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col xs={3} sm={4} xl={2} className="text-sm-right">
                          <FormLabel className="m-0">
                            หมายเหตุ
                            <span className="text-danger font-weight-bold">
                              *
                            </span>
                          </FormLabel>
                        </Col>
                        <Col className="px-2">
                          <FormControl
                            as="textarea"
                            rows={4}
                            value={inventoryDetail.note}
                            onChange={(e) =>
                              handleChange('note', e.target.value)
                            }
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col sm={6} md={5} xl={3} className="px-2">
                      <Row className="align-items-center px-1 py-2">
                        <Col
                          xs={4}
                          sm={5}
                          xl={5}
                          className="px-2 text-sm-right"
                        >
                          <FormLabel className="m-0">จำนวนหลังปรับ</FormLabel>
                        </Col>
                        <Col className="px-2">
                          <FormControl
                            className="text-right"
                            value={
                              inventoryDetail.adjustUnitQty
                                ? inventoryDetail.afterUnitQty
                                : ''
                            }
                            readOnly
                          />
                        </Col>
                        <span>unit / </span>
                      </Row>
                    </Col>
                    <Col sm={6} md={5} xl={2} className="px-2 ">
                      <Row className="align-items-center px-1 py-2">
                        <Col className="px-2">
                          <FormControl
                            className="text-right"
                            value={
                              inventoryDetail.adjustUnitQty
                                ? inventoryDetail.afterPackQty
                                : ''
                            }
                            readOnly
                          />
                        </Col>
                        <span>pack</span>
                      </Row>
                    </Col>

                    <Col xs={12} className="text-right">
                      <SingleButton
                        cooldown={0}
                        loadingText="กำลังบันทึก..."
                        variant="outline-primary"
                        onClick={() => saveAdjust()}
                      >
                        สร้างรายการปรับยอด
                      </SingleButton>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <MaterialTable
                tableRef={tableRef}
                columns={column}
                data={async (query) => {
                  if (inventoryLotId) {
                    try {
                      const { page, pageSize } = query
                      let res = await StockApiStore.getInventoryLotAdjust(
                        inventoryLotId,
                        page + 1,
                        pageSize,
                      )
                      return {
                        data: res.data?.data,
                        page: res.data?.pagination?.page - 1,
                        totalCount: res.data?.pagination?.total,
                      }
                    } catch (error) {
                      console.error(error)
                    }
                  } else {
                    return {
                      data: [],
                      page: 0,
                      totalCount: 0,
                    }
                  }
                }}
                options={{
                  toolbar: false,
                  search: false,
                  showTitle: false,
                }}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}
